// What an avatar looks like for a given name — the same answer whether it is
// the Avatar component asking or a caller painting its own tile. Kept out of
// Avatar.tsx so that file exports a component and nothing else.

// 8 gradient pairs — assigned deterministically per name. Mockup section 16.
const PALETTE = [
  "linear-gradient(135deg, #10b981, #0f766e)",
  "linear-gradient(135deg, #f97316, #ef4444)",
  "linear-gradient(135deg, #3b82f6, #1e40af)",
  "linear-gradient(135deg, #a855f7, #6b21a8)",
  "linear-gradient(135deg, #f59e0b, #b45309)",
  "linear-gradient(135deg, #ec4899, #be185d)",
  "linear-gradient(135deg, #14b8a6, #0e7490)",
  "linear-gradient(135deg, #84cc16, #4d7c0f)",
];

function hashName(name: string): number {
  let sum = 0;
  for (let i = 0; i < name.length; i++) {
    sum = (sum + name.charCodeAt(i) * (i + 1)) >>> 0;
  }
  return sum;
}

export function gradientFor(name: string): string {
  return PALETTE[hashName(name) % PALETTE.length];
}

export function initialsFor(name: string | undefined): string {
  const n = (name ?? "").trim();
  if (!n) return "?";
  const parts = n.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  return n.slice(0, 2).toUpperCase();
}
